import QueryString from "query-string";
import { all, call, put, select, takeEvery } from "redux-saga/effects";
import api from "../../utils/api";
import { errorAlert, successAlert } from "../Alerts/actions";
import {
  addTeamSuccess,
  addTeamFailure,
  //
  deleteTeamSuccess,
  deleteTeamFailure,
  //
  editTeamSuccess,
  editTeamFailure,
  //
  fetchTeams as fetchTeamAction,
  fetchTeamsSuccess,
  fetchTeamsFailure,
  //
  getViewData as getViewDataAction,
  getViewDataFailure,
  getViewDataSuccess,
  searchTeamsSuccess,
  searchTeamsFailure,
} from "./actions";
import {
  ADD_TEAM,
  DELETE_TEAM,
  EDIT_TEAM,
  FETCH_TEAMS,
  GET_VIEW_DATA,
  SEARCH_TEAMS,
} from "./constants";

export function* fetchTeamsSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload?.data ? QueryString.stringify(payload?.data) : "";
  try {
    const { data } = yield call(api(token).get, `/api/team?${query}`);
    yield put(fetchTeamsSuccess(data));
  } catch (e) {
    yield put(fetchTeamsFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching team list!"));
  }
}

export function* getViewDataSaga({ payload = { cancelToken: null } }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload ? QueryString.stringify(payload) : "";
  try {
    const { data } = yield call(api(token).get, `/api/team/${payload}`);
    yield put(getViewDataSuccess(data));
  } catch (e) {
    yield put(getViewDataFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching team data!"));
  }
}

export function* addTeamSaga({ payload, onSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(api(token).post, `/api/team/add`, payload);
    if (data) {
      yield put(successAlert("Team created successfully!"));
      yield put(addTeamSuccess());
      typeof onSuccess === "function" && onSuccess();
    }
  } catch (e) {
    yield put(addTeamFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* editTeamSaga({ payload, onSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token).post,
      `/api/team/edit/${payload.id}`,
      payload
    );
    if (data) {
      yield put(successAlert("Team updated successfully!"));
      yield put(editTeamSuccess());
      yield put(getViewDataAction(payload.id));
      typeof onSuccess === "function" && onSuccess();
    }
  } catch (e) {
    yield put(editTeamFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* deleteTeamSaga({ payload, onDelete }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(api(token).delete, `/api/team/${payload}`);
    if (data) {
      yield put(successAlert("Team deleted successfully!"));
      yield put(deleteTeamSuccess());
      typeof onDelete === "function" && onDelete();
    }
  } catch (e) {
    yield put(deleteTeamFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* searchTeamsSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload ? QueryString.stringify(payload) : "";
  try {
    const { data } = yield call(api(token).get, `/api/team?${query}`);
    yield put(searchTeamsSuccess(data));
  } catch (e) {
    yield put(searchTeamsFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while searching team list!"));
  }
}

export function* fetchTeamsFlow() {
  yield takeEvery(FETCH_TEAMS, fetchTeamsSaga);
}
export function* getViewDataFlow() {
  yield takeEvery(GET_VIEW_DATA, getViewDataSaga);
}
export function* addTeamFlow() {
  yield takeEvery(ADD_TEAM, addTeamSaga);
}
export function* editTeamFlow() {
  yield takeEvery(EDIT_TEAM, editTeamSaga);
}
export function* deleteTeamFlow() {
  yield takeEvery(DELETE_TEAM, deleteTeamSaga);
}
export function* searchTeamsFlow() {
  yield takeEvery(SEARCH_TEAMS, searchTeamsSaga);
}

export default function* TeamSaga() {
  yield all([
    fetchTeamsFlow(),
    addTeamFlow(),
    editTeamFlow(),
    deleteTeamFlow(),
    getViewDataFlow(),
    searchTeamsFlow(),
  ]);
}
